// src/pages/admin/AdminDashboard.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/admin/AdminDashboard.css';

const AdminDashboard = () => {
  return (
    <div className="admin-dashboard">
      <h1 className="admin-dashboard-title">Admin Dashboard</h1>
      <p className="admin-dashboard-subtitle">
        Welcome to the DKL Books Admin Panel. Manage your bookstore with full control.
      </p>

      <div className="admin-dashboard-grid">
        {/* Manage Books */}
        <Link to="/admin/books" className="admin-card admin-card-primary">
          <h3 className="admin-card-title">Manage Books</h3>
          <p className="admin-card-description">
            View, edit, delete, and organize all books in the store
          </p>
        </Link>

        {/* Add New Book */}
        <Link to="/admin/add-book" className="admin-card admin-card-success">
          <h3 className="admin-card-title">Add New Book</h3>
          <p className="admin-card-description">
            List a new Nepali novel with cover, details, and pricing
          </p>
        </Link>

        {/* Manage Featured */}
        <Link to="/admin/manage-featured" className="admin-card admin-card-featured">
          <h3 className="admin-card-title">Manage Featured</h3>
          <p className="admin-card-description">
            Curate which books appear in the Featured section on homepage
          </p>
        </Link>

        {/* Manage Best Sellers */}
        <Link to="/admin/manage-bestsellers" className="admin-card admin-card-bestseller">
          <h3 className="admin-card-title">Manage Best Sellers</h3>
          <p className="admin-card-description">
            Highlight top-selling or popular books
          </p>
        </Link>

        {/* Manage New Arrivals */}
        <Link to="/admin/manage-new-arrivals" className="admin-card admin-card-new">
          <h3 className="admin-card-title">Manage New Arrivals</h3>
          <p className="admin-card-description">
            Showcase the latest additions to your collection
          </p>
        </Link>

        {/* Manage Orders - NEW */}
        <Link to="/admin/orders" className="admin-card admin-card-orders">
          <h3 className="admin-card-title">Manage Orders</h3>
          <p className="admin-card-description">
            View, update status, and track all customer orders
          </p>
        </Link>
      </div>

      <div className="admin-dashboard-footer-note">
        <p>More features coming soon: Analytics • Stock Control • Customer Messages</p>
      </div>
    </div>
  );
};

export default AdminDashboard;